define('app/views/question_ask_view',['app/setup'], function(takhfifan) {

  takhfifan.QuestionAskView = Backbone.View.extend({

    events: {
      'submit': 'submitQuestion'
    },

    initialize: function() {
      Backbone.Validation.bind(this);
      var _this = this;
      this.customerData = null;

      this.model.set({product_id: this.$el.data('productId')});

      takhfifan.eventHub.on('customer:login', function(data) {
        this.customerData = data;

        this.$el.find('#author_name').val(data.name).prop("disabled", true);
        this.$el.find('#author_email').val(data.email).prop("disabled", true);

        if(data.mobile){
          this.$el.find('#author_phone_number').val(data.mobile).prop("disabled", true);
        }

        this.model.isLoggedIn = true;
      }, this);

      takhfifan.eventHub.on('formkey', function(formKey) {
        this.$el.show();
        this.model.set('form_key', formKey);
      }, this);

      this.model.on('submit:success', function(message){
        if(this.model.isLoggedIn){
          takhfifan.eventHub.trigger('customer:login', this.customerData);
        }
        this.showSuccess(message);
      }, this);

      this.model.on('submit:error', function(message){
        this.showError(message);
      }, this);

      this.model.on('validated:invalid', function(model, errors) {
        var $eList = $("<ul style='float:right' />");
        _.each(errors, function(value,key){
          $eList.append("<li>"+value+"</li>");
        });

        this.$('.tkh-success-container').hide();
        var $container = this.$('.tkh-error-container');
        $container.find('.tkh-error-message').html($eList);
        $container.slideDown();
      }, this);


      var commentEl = $('.deal-questions-wrapper .deal-page-card-cnt > .comment');
      
      if(commentEl.length > 2){
        var initCommentsHeight1 = commentEl.eq(0).innerHeight();
        var initCommentsHeight2 = commentEl.eq(1).innerHeight();
        $('.deal-questions-wrapper').find('.deal-page-card-cnt').height(initCommentsHeight1 + initCommentsHeight2 + 28);
      }
      $('.deal-questions-wrapper').find('.deal-page-card-loading').fadeOut();
      
      $('.show-all-comments-btn').on('click', function() {
        _this.showAllComments();
        $(this).attr('disabled', true);
      });
    },
    
    showAllComments: function() {
      $('.deal-questions-wrapper .deal-page-card-cnt').height('auto');
    },

    showSuccess: function(message) {
      this.$('.tkh-error-container').hide();
      var $container = this.$('.tkh-success-container');
      $container.nextAll().remove();
      $container.find('.tkh-success-message').html(message);
      $container.slideDown();
    },

    showError: function(message) {
      this.$('.btn[type="submit"]').removeAttr("disabled");
      this.$('.tkh-success-container').hide();
      var $container = this.$('.tkh-error-container');
      $container.find('.tkh-error-message').html(message);
      $container.slideDown();
    },

    submitQuestion: function(event) {
      event.preventDefault();
      var commentData = {
        content: this.$('textarea').val()
      };

      commentData["author_email"] = this.$('#author_email').val();
      commentData["author_name"] = this.$('#author_name').val();
      commentData["author_phone_number"] = this.$('#author_phone_number').val();

      this.model.set(commentData, {validate: true});

      if(this.model.isValid()) {
        this.$('.btn[type="submit"]').attr("disabled","disabled");
        if(this.model.isLoggedIn && this.customerData.mobile === null){
          this.customerData['mobile'] = this.$('#author_phone_number').val();
        }
        this.model.submit(this.$el.data('url'));
        return true;
      }
      return false;
    }

  });

});

